import type {RosterComparisonStore} from '../../lib/stores/roster-comparison-store';
import type {ComparisonRow} from '../../lib/comparison-row';

export type ComparisonRows = {
    // Response rows, one per specialty; null until a response has arrived
    rows: ComparisonRow[] | null;
    loading: boolean;
    // The last request failed (an aborted one does not count)
    failed: boolean;
};

/**
 * The rows the summary describes, and the state of the request behind them
 *
 * The panel's only data source. The rows are the network adequacy comparison response the table
 * already requests and stores, so the panel makes no request of its own and cannot describe a
 * different result from the table beside it. Must be called from an observer component, so the
 * store reads below are tracked.
 *
 * @param store - The comparison store holding the response
 */
export function useComparisonRows(store: RosterComparisonStore): ComparisonRows {
    // Narrowed to the selected specialties, as the table beside the panel shows them
    return {
        rows: store.filteredComparisonData,
        loading: store.loadingComparisonData,
        failed: store.comparisonLoadFailed,
    };
}
